import React, { useState, useEffect } from "react";
import GoogleIcon from '@mui/icons-material/Google';
import { authActions } from "../../../redux-store";
import { ToastContainer, toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import sessionstorage from "sessionstorage";
import backend from "../../../api";
import { useNavigate } from "react-router-dom";
// import './Auth.css';
import { useLocation } from 'react-router-dom';
import { motion, easeOut, AnimatePresence } from 'framer-motion';
import Classes from '../Signup/Auth.module.css'
import CryptoJS from 'crypto-js';
import Logo from "../Home/Components/Logo/Logo";

const CursorIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 320 512"><path d="M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z" /></svg>
)
const FileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 54.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z" /></svg>
)
const ShieldIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 47-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z" /></svg>
)

const LoadingSpinner = () => (
  <div class="loadingio-spinner-eclipse-nq4q5u6dq7r">
    <div class="ldio-x2uulkbinbj">
      <div></div>
    </div>
  </div>
)

export default function Login() {
  const [width, setWidth] = useState(window.innerWidth);
  const [state, setState] = useState("signin");
  const { user } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState();
  const [incorrectError, setIncorrectError] = useState(false);
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const [showEye, setshowEye] = useState(false);
  const [passwordMatchingError, setpasswordMatchingError] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [passwordLengthError, setpasswordLengthError] = useState(false);
  const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);

  const [emailSentMsg, setEmailSentMsg] = useState(false);
  const [userId, setUserId] = useState("");


  const loginSubmitHandler = async (e) => {
    e.preventDefault();
    setIncorrectError(false);
    setLoading(true);
    const sideBar = sessionStorage.getItem('navBtn');

    const isLogin = await dispatch(authActions.login(email, password));

    if (isLogin) {
      setLoading(false);
      if (sideBar === "Pitch Deck Templates") {
        navigateTo(`/templates`);
      } else {
        navigateTo("/");
      }
    } else {
      setLoading(false);
      setIncorrectError(true);
    }
  };



  const fetchUserId = async () => {
    try {
      const res = await backend.get(`/user?email=${email}`);
      setUserId(res?.data._id);
    } catch (error) {
      console.error("Failed to fetch user id:", error);
    }
  };


  const ForgotHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await fetchUserId();

    try {
      const resetLink = `/createpassword/${userId}`;
      const isForgot = await dispatch(authActions.forgotPassword(email, resetLink));
      if (isForgot) {
        setLoading(false);
        setInvalidEmailError(false);
        setEmailSentMsg(true);
        setTimeout(() => {
          setInvalidEmailError(false);
          setEmailSentMsg(false);
        }, 10000);
      } else {
        setLoading(false);
        setEmailSentMsg(false);
        setInvalidEmailError(true);
        setTimeout(() => {
          setInvalidEmailError(false);
          setEmailSentMsg(false);
        }, 10000);
      }
    } catch (err) {
      setLoading(false);
      console.error('Network error:', err);
      setInvalidEmailError(true);
      setTimeout(() => {
        setInvalidEmailError(false);
      }, 10000);
    }
  };



  return (
    <>
      <div className={Classes.signUp} >
        <div className={Classes.signUpGridLeft} >
          <AnimatePresence mode="wait">
            {state === "signin" && (
              <motion.div
                key="signIn"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{
                  duration: 0.3,
                  ease: easeOut,
                }}
              >
                <form className={Classes.signUpInnerCon} onSubmit={loginSubmitHandler}>
                  <a href="/" className={Classes.miniLogo2} style={{ textDecoration: 'none' }} >
                    <h1 style={{ color: 'black' }} >Mentr</h1>
                  </a>
                  <h5 className={Classes.heading2} >Welcome back</h5>
                  <p className={Classes.subtitle} style={{ textAlign: 'start' }} >Log in to Mentr to monetize your mentorship or browse mentors, book meetings, and get personalized guidance.</p>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                    style={{ width: '100%' }}
                  />
                  <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      type={showEye ? "text" : "password"}
                      placeholder="Enter your password"
                      required
                    />
                    {showEye ?
                      <>
                        <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                      </>
                      :
                      <>
                        <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                      </>
                    }
                  </div>
                  {incorrectError && <p className={Classes.error}>*Username or Password is incorrect</p>}
                  <div className={Classes.flexBetween} >
                    <div className={Classes.flexAlign} ></div>
                    <button type="button" onClick={() => setState('forgot')} className={Classes.forgotPasswordButton}>
                      Forgot password?
                    </button>
                  </div>
                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading}>
                    Sign in
                    {loading && <LoadingSpinner />}
                  </button>
                  <p className={Classes.signupLink2}>
                    Don't have an account?
                    <button type="button" onClick={() => { navigateTo('/join') }} className={Classes.linkButton}>
                      Sign up
                    </button>
                  </p>
                </form>
              </motion.div>
            )}
            {state === "forgot" && (
              <motion.div
                key="forgot"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{
                  duration: 0.3,
                  ease: easeOut,
                }}
              >
                <form className={Classes.signUpInnerCon} onSubmit={ForgotHandler}>
                  <a href="/" className={Classes.miniLogo2} style={{ textDecoration: 'none' }} >
                    <h1 style={{ color: 'black' }} >Mentr</h1>
                  </a>
                  <h5 className={Classes.heading2} >Forgot Password</h5>
                  <p className={Classes.subtitle} style={{ textAlign: 'start' }} >Enter your email address and we will send you instructions to
                    reset your password.</p>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                    style={{ width: '100%' }}
                  />
                  {invalidEmailError && <p className={Classes.error}>*Enter valid registered email.</p>}
                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                    Continue
                    {loading && <LoadingSpinner />}
                  </button>
                  <p onClick={() => setState("signin")} className={Classes.signupLink2} style={{ cursor: 'pointer' }} >
                    Back to sign in page
                  </p>
                </form>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.3,
            ease: easeOut,
          }}
          className={Classes.signUpGridRight}
        >
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 0.5,
              ease: easeOut,
              delay: 0.3
            }}
            className={Classes.signUpInnerCon2}
          >
            <h5 className={Classes.title3} > Welcome back—find your next mentor and schedule a session. </h5>
            <br />
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/mentee-1.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} > Find Your Perfect Match </h5>
                <h5 className={Classes.miniText2} > Use smart filters to browse mentors by expertise, price, availability, and ratings—get exactly what you need. </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/mentee-2.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} > Book Instantly </h5>
                <h5 className={Classes.miniText2} > Seamlessly book sessions through Calendly, Cal, and more. No back-and-forth, just instant scheduling. </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/mentee-3.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} > Pay as You Go </h5>
                <h5 className={Classes.miniText2} > Only pay per session—no subscriptions. Secure payments with a transparent fee structure. </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/mentee-4.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} > Real Reviews, Trusted Mentors </h5>
                <h5 className={Classes.miniText2} > Every mentor is rated by real mentees. See honest feedback before you book. </h5>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </>
  );
}